export enum AnnouncementResponse {
  NotInterested = 0,
  Interested = 1,
}
